import { render } from "./Share.vue?vue&type=template&id=45363cc4&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=45363cc4&lang=css"
import "./Share.vue?vue&type=style&index=1&id=45363cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45363cc4"]])

export default __exports__